import { LOGO_URL } from '../../data/parasHomeData';

export default function Footer() {
  return (
    <footer className="footer" id="contact" role="contentinfo">
      <div className="footer-inner">
        <div className="footer-grid">
          <div className="footer-brand">
            <img src={LOGO_URL} alt="Paras Organics" />
            <p>Premium organic fertilizers made from cow dung and earthworms. No chemicals. No compromise. Produced and marketed by Avasthi Enterprise, Gandhinagar, Gujarat.</p>
            <div className="footer-contact">
              <div>Location: Vehlal, Naroda - Dehgam Road, Gandhinagar, Gujarat</div>
              <div>Phone: <a href="tel:+917405001130">+91 74050 01130</a></div>
              <div>Email: <a href="mailto:goparas@gmail.com">goparas@gmail.com</a></div>
            </div>
            <div className="social-links" style={{ marginTop: '1.25rem' }}>
              <a href="https://facebook.com" className="social-link" aria-label="Facebook" target="_blank" rel="noreferrer">Fb</a>
              <a href="https://instagram.com" className="social-link" aria-label="Instagram" target="_blank" rel="noreferrer">Ig</a>
              <a href="https://youtube.com" className="social-link" aria-label="YouTube" target="_blank" rel="noreferrer">Yt</a>
              <a href="https://wa.me/917405001130" className="social-link" aria-label="WhatsApp" target="_blank" rel="noreferrer">Wa</a>
            </div>
          </div>
          <div className="footer-col">
            <h4>Products</h4>
            <ul>
              <li><a href="/vermicompost">Vermicompost</a></li>
              <li><a href="/vermiwash">Vermiwash</a></li>
            </ul>
          </div>
          <div className="footer-col">
            <h4>Quick Links</h4>
            <ul>
              <li><a href="/">Home</a></li>
              <li><a href="/about">About Us</a></li>
              <li><a href="/blog">Blog</a></li>
              <li><a href="/videos">Videos</a></li>
              <li><a href="/testimonials">Testimonials</a></li>
              <li><a href="/faq">FAQs</a></li>
              <li><a href="/contact">Contact Us</a></li>
            </ul>
          </div>
          <div className="footer-col">
            <h4>Applications</h4>
            <ul>
              <li><a href="/applications/home-garden">Home & Garden</a></li>
              <li><a href="/applications/agriculture">Agriculture</a></li>
              <li><a href="/applications/nursery-landscaping">Nursery & Landscaping</a></li>
            </ul>
          </div>
          <div className="footer-col">
            <h4>Customer</h4>
            <ul>
              <li><a href="/login">Login / Sign Up</a></li>
              <li><a href="/my-account">My Account</a></li>
              <li><a href="/orders">My Orders</a></li>
              <li><a href="/cart">Cart</a></li>
              <li><a href="/return-policy">Return Policy</a></li>
              <li><a href="/privacy-policy">Privacy Policy</a></li>
              <li><a href="/terms">Terms & Conditions</a></li>
            </ul>
          </div>
        </div>
        <div className="footer-bottom">
          <div>© 2025 Paras Organics · Avasthi Enterprise · All Rights Reserved</div>
          <div style={{ display: 'flex', gap: '1.5rem', flexWrap: 'wrap' }}>
            <a href="/privacy-policy">Privacy Policy</a>
            <a href="/terms">Terms & Conditions</a>
            <a href="/return-policy">Return Policy</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
